import { Logo } from "./Brand";

export const Footer = ({ home = true }) => (
  <footer className="bg-[#0B1938] text-white pt-16 sm:pt-20 pb-10" data-testid="site-footer">
    <div className="max-w-7xl mx-auto px-5 sm:px-10">
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-6">
        <Logo light testId="footer-logo" href={home ? "#top" : "/"} />
        <a href={home ? "#signup" : "/#signup"} data-testid="footer-signup-link" className="rounded-full border border-white/25 px-6 py-3 font-bold hover:bg-white hover:text-[#13296B] transition-colors duration-300 self-start">Drivers: sign up now</a>
      </div>
      <div className="mt-12 pt-8 border-t border-white/10 flex flex-col sm:flex-row justify-between gap-3 text-sm text-slate-400">
        <p>© {new Date().getFullYear()} Marketgetr. App coming soon.</p>
        <div className="flex items-center gap-6">
          <a href="/blog" data-testid="footer-blog-link" className="font-semibold text-slate-300 hover:text-white transition-colors">Blog</a>
          <p className="font-mono" data-testid="footer-domain">marketgetr.com</p>
        </div>
      </div>
    </div>
  </footer>
);
